<div class="report-list">
  @if (filteredReports.length===0) {
    <div class="no-reports">
      <mat-icon class="no-reports-icon">analytics</mat-icon>
    </div>
  }

  @if (filteredReports.length>0) {
    <div class="container-fluid container-format">
      @for (row of gridRows; track row) {
        <div class="row row-format">
          @for (col of row; track col) {
            <div class="col col-format">
              <div style="min-width: 325px;">
                <app-report-item [report]="col" [size]="itemSize" (favorite)="setItemFavorite()"></app-report-item>
              </div>
            </div>
          }
        </div>
      }
    </div>
  }
</div>

<app-rating-viewer></app-rating-viewer>